export const COUNTRY_DIAL_CODES = [
  { code: 'US', name: 'United States',        dial: '+1',   min: 10, max: 10 },
  { code: 'CA', name: 'Canada',               dial: '+1',   min: 10, max: 10 },
  { code: 'IN', name: 'India',                dial: '+91',  min: 10, max: 10 },
  { code: 'GB', name: 'United Kingdom',       dial: '+44',  min: 10, max: 10 },
  { code: 'AU', name: 'Australia',            dial: '+61',  min: 9,  max: 9  },
  { code: 'NZ', name: 'New Zealand',          dial: '+64',  min: 8,  max: 10 },
  { code: 'IE', name: 'Ireland',              dial: '+353', min: 7,  max: 9  },
  { code: 'DE', name: 'Germany',              dial: '+49',  min: 10, max: 11 },
  { code: 'FR', name: 'France',               dial: '+33',  min: 9,  max: 9  },
  { code: 'IT', name: 'Italy',                dial: '+39',  min: 9,  max: 10 },
  { code: 'ES', name: 'Spain',                dial: '+34',  min: 9,  max: 9  },
  { code: 'PT', name: 'Portugal',             dial: '+351', min: 9,  max: 9  },
  { code: 'NL', name: 'Netherlands',          dial: '+31',  min: 9,  max: 9  },
  { code: 'BE', name: 'Belgium',              dial: '+32',  min: 8,  max: 9  },
  { code: 'CH', name: 'Switzerland',          dial: '+41',  min: 9,  max: 9  },
  { code: 'AT', name: 'Austria',              dial: '+43',  min: 10, max: 11 },
  { code: 'SE', name: 'Sweden',               dial: '+46',  min: 7,  max: 9  },
  { code: 'NO', name: 'Norway',               dial: '+47',  min: 8,  max: 8  },
  { code: 'DK', name: 'Denmark',              dial: '+45',  min: 8,  max: 8  },
  { code: 'FI', name: 'Finland',              dial: '+358', min: 9,  max: 10 },
  { code: 'PL', name: 'Poland',               dial: '+48',  min: 9,  max: 9  },
  { code: 'CZ', name: 'Czech Republic',       dial: '+420', min: 9,  max: 9  },
  { code: 'GR', name: 'Greece',               dial: '+30',  min: 10, max: 10 },
  { code: 'TR', name: 'Turkey',               dial: '+90',  min: 10, max: 10 },
  { code: 'RU', name: 'Russia',               dial: '+7',   min: 10, max: 10 },
  { code: 'UA', name: 'Ukraine',              dial: '+380', min: 9,  max: 9  },
  { code: 'BR', name: 'Brazil',               dial: '+55',  min: 10, max: 11 },
  { code: 'MX', name: 'Mexico',               dial: '+52',  min: 10, max: 10 },
  { code: 'AR', name: 'Argentina',            dial: '+54',  min: 10, max: 11 },
  { code: 'CL', name: 'Chile',                dial: '+56',  min: 8,  max: 9  },
  { code: 'CO', name: 'Colombia',             dial: '+57',  min: 10, max: 10 },
  { code: 'AE', name: 'United Arab Emirates', dial: '+971', min: 8,  max: 9  },
  { code: 'SA', name: 'Saudi Arabia',         dial: '+966', min: 9,  max: 9  },
  { code: 'IL', name: 'Israel',               dial: '+972', min: 8,  max: 9  },
  { code: 'ZA', name: 'South Africa',         dial: '+27',  min: 9,  max: 9  },
  { code: 'NG', name: 'Nigeria',              dial: '+234', min: 10, max: 10 },
  { code: 'KE', name: 'Kenya',                dial: '+254', min: 9,  max: 9  },
  { code: 'EG', name: 'Egypt',                dial: '+20',  min: 10, max: 10 },
  { code: 'JP', name: 'Japan',                dial: '+81',  min: 10, max: 10 },
  { code: 'KR', name: 'South Korea',          dial: '+82',  min: 9,  max: 10 },
  { code: 'CN', name: 'China',                dial: '+86',  min: 11, max: 11 },
  { code: 'HK', name: 'Hong Kong',            dial: '+852', min: 8,  max: 8  },
  { code: 'TW', name: 'Taiwan',               dial: '+886', min: 9,  max: 9  },
  { code: 'SG', name: 'Singapore',            dial: '+65',  min: 8,  max: 8  },
  { code: 'MY', name: 'Malaysia',             dial: '+60',  min: 9,  max: 10 },
  { code: 'TH', name: 'Thailand',             dial: '+66',  min: 9,  max: 9  },
  { code: 'ID', name: 'Indonesia',            dial: '+62',  min: 9,  max: 12 },
  { code: 'PH', name: 'Philippines',          dial: '+63',  min: 10, max: 10 },
  { code: 'VN', name: 'Vietnam',              dial: '+84',  min: 9,  max: 10 },
  { code: 'PK', name: 'Pakistan',             dial: '+92',  min: 10, max: 10 },
  { code: 'BD', name: 'Bangladesh',           dial: '+880', min: 10, max: 10 },
  { code: 'LK', name: 'Sri Lanka',            dial: '+94',  min: 9,  max: 9  },
];

export const findByCode = (iso) => COUNTRY_DIAL_CODES.find(c => c.code === iso);

export const validatePhone = (iso, digits) => {
  const c = findByCode(iso);
  if (!c) return false;
  const n = String(digits || '').replace(/\D/g, '');
  return n.length >= c.min && n.length <= c.max;
};

export const stripNonDigits = (s) => String(s || '').replace(/\D/g, '');
